import React, { useEffect, useRef } from "react";
import { GdkAddressAutoComplete } from "@gdk/address-auto-complete";
import { useClientConfigs } from "../contexts/ClientConfigContext";

interface AddressSearchProps {
  id: string;
  setFieldValue: (field: string, value: string) => void;
  value: string;
  enteredZip: string;
  highlight?: boolean;
  horizontalLayout?: boolean;
}

const generateUniqueId = () => {
  return `id-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .substr(2, 5)}`;
};

const AddressSearch: React.FC<AddressSearchProps> = ({
  id,
  setFieldValue,
  value,
  enteredZip,
  highlight = false,
  horizontalLayout
}) => {
  const uniqueId = `${id}-${horizontalLayout ? 'main-page' : 'sidebar'}`;
  const idRef = useRef(uniqueId);
  const gdkAddressAutoCompleteRef = useRef<any>(null);
  const clientConfig = useClientConfigs();

  useEffect(() => {
    if (!gdkAddressAutoCompleteRef.current) {
      gdkAddressAutoCompleteRef.current = new GdkAddressAutoComplete({
        content: `#${idRef.current}-addressAutoComplete`,
        apiKey: clientConfig.radarApiKey,
        queryParameters: {
          limit: 10,
          country: "US, PR",
          layers: "fine",
          debounceMs: 300,
          threshold: 3,
        },
        onSelectAddress: handleSelectAddress,
      } as any);
    }
  }, [clientConfig.radarApiKey]);

  const handleSelectAddress = () => {
    const addressData = gdkAddressAutoCompleteRef.current?.getAddressData();
    if (addressData) {
      const streetAddress = addressData.formattedAddress;
      setFieldValue(id, streetAddress);
      if (addressData.postalCode !== enteredZip) {
        setFieldValue("zipCode", addressData.postalCode);
      }
    }
  };

  return (
    <div
      className={`address-auto-complete`}
      id={`${idRef.current}-addressAutoComplete`}
    >
      <div className={"form-field"}>
        <label
          htmlFor={`${idRef.current}-address-search-field`}
          id={`${idRef.current}-address-search-field-label`}
        ></label>
        <div className="search-field-wrapper">
          <input
            aria-labelledby={`${idRef.current}-address-search-field-label`}
            id={`${idRef.current}-address-search-field`}
            className="address-search-field"
            name={`${idRef.current}-address-search-field`}
            type="text"
            value={value || ""}
            autoComplete="off"
            spellCheck="false"
            onChange={(event) => setFieldValue(id, event.target.value)}
            style={{ width: "100%", borderColor: highlight ? 'red' : undefined }}
          />
          <input
            id="address_1"
            name="route"
            className="address_1 none"
            type="text"
            value={value || ""}
            aria-hidden="true"
            readOnly={true}
          />
        </div>
      </div>
    </div>
  );
};

export default AddressSearch;
